/** @format */

import React, { FC, useRef, useState } from 'react'
import { useAsync } from 'react-use'
import { Form, FormItem, Input, Message, Drawer } from '@king-design/react'
import {
  getPrometheusRecord,
  createPrometheusRecord,
  updatePrometheusRecord
} from 'src/api/ApiPromethuesInstance'
import styled from 'styled-components'
import YamlCodemirror from 'src/components/YamlCodemirror'
import { initRecordFormValues, RecordFormValue, initYaml } from './constants'
import yaml from 'js-yaml'

interface RecordEditProps {
  className?: string
  visible: boolean
  onClose: (update?: boolean) => void
  instanceID: string
  ID?: number
}

const RecordEdit: FC<RecordEditProps> = ({ className, visible, onClose, ID, instanceID }) => {
  // form表单
  const formRef = useRef(null)
  const [formValue, setFormValue] = useState<RecordFormValue>()
  const { value } = useAsync(async () => {
    if (visible && ID) {
      const result = await getPrometheusRecord(ID)
      if (result) {
        setFormValue({
          Name: result.Name,
          Records: result.Records
            ? yaml.dump(
                result.Records.map(label => ({
                  record: label.record,
                  expr: label.expr || {},
                  labels: label.labels
                }))
              )
            : initYaml
        })
      }
      return result
    } else {
      setFormValue(initRecordFormValues)
    }
  }, [visible, ID])

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    try {
      if (validate) {
        const { Name, Records } = formValue
        const recordsJson = yaml?.load?.(Records)
        const params = {
          InstanceID: instanceID,
          Name,
          Records: recordsJson.map((item, index) => ({
            id: value?.Records?.[index]?.ID || 0,
            ...item
          }))
        }
        const result = ID
          ? await updatePrometheusRecord({
              ID: ID,
              ...params
            })
          : await createPrometheusRecord({
              ...params
            })
        if (result?.code === 'Success') {
          Message.success('操作成功')
          onClose(true)
          setFormValue(initRecordFormValues)
        }
      }
    } catch (e) {
      Message.error('YAML格式错误，请检查后重新提交')
      return false
    }
  }

  return (
    <div className={className} id="record_edit_drawer">
      {visible ? (
        <Drawer
          width={800}
          title={ID ? '编辑预聚合规则' : '新建预聚合规则'}
          value={visible}
          onClose={() => onClose()}
          container={() => document.getElementById('record_edit_drawer')}
          mode="destroy"
          onChangeValue={show => {
            if (!show) {
              onClose()
              setFormValue(initRecordFormValues)
            }
          }}
          ok={() => formSubmit()}
        >
          <Form className="form_container" starOnRequired ref={formRef} labelWidth={120}>
            <FormItem
              label="预聚合规则名称"
              value={formValue.Name}
              rules={{ required: true, userName: true }}
            >
              <Input
                value={formValue.Name}
                onChangeValue={value => {
                  setFormValue({ ...formValue, Name: value })
                }}
              />
            </FormItem>
            <FormItem
              label="预聚合规则"
              value={formValue.Records}
              rules={{ required: true }}
              className="form_item_yaml"
            >
              <YamlCodemirror
                value={formValue.Records}
                visible={visible}
                onChange={value => {
                  setFormValue({ ...formValue, Records: value })
                }}
              />
            </FormItem>
          </Form>
        </Drawer>
      ) : null}
    </div>
  )
}

export default styled(RecordEdit)`
  .k-form-label {
    .ion-help-circled {
      margin-left: 4px;
    }
  }
  .form_item_yaml {
    .k-form-content {
      width: 632px;
    }
  }
`
